module.exports = __webpack_public_path__ + "img/ico_folder_open.39c24273.svg";